export const logoVariants = {
    initial: {
        opacity: 0
    }, animate: {
        opacity: 1,
        transition: {
            duration: 1,
            eae: "easeIn"
        }
    }, exit: {
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: "easeOut"
        }
    }
}

export const bgVariants = {
    initial: {
        background: "var(--dark-color)"
    }, animate: {
        background: "var(--light-color)",
        transition: {
            duration: 1,
            ease: [0.76, 0, 0.24, 1]
        }
    },  exit: {
        background: "var(--dark-color)",
        transition: {
            delay: 0.75,
            duration: 1,    
            ease: [0.76, 0, 0.24, 1]
        }
    }
}

export const imgWrapVariants = {
    initial: {
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
    }, animate: {
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
    }, exit: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: 0.75,
            delay: 0.3,
            ease: [0.5, 0, 0.75, 0]
        }
    }
}

export const standardItemVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)",
        opacity: 0
    },
    animate:(i) => ({
        transform: "translate3d(0, 0%, 0)",
        opacity: 1,
        transition: {
            duration: 1,
            delay: 0.25 + 0.05 * i,
            ease: [0.16, 1, 0.3, 1],
            opacity: {
                duration: 0.45,
                ease: "easeIn",
                delay: 0.25 + 0.05 * i,
            }
        }
    }),
    exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            delay: i * 0.0125,
            ease: [0.7, 0, 0.84, 0]
        }
    })
}

export const largeItemVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)",
        opacity: 0
    },
    animate:(i) => ({
        transform: "translate3d(0, 0%, 0)",
        opacity: 1,
        transition: {
            duration: 1.5,
            delay: 0.25 + 0.05 * i,
            ease: [0.16, 1, 0.3, 1],
            opacity: {
                duration: 0.75,
                ease: "easeIn",
                delay: 0.25 + 0.05 * i,
            }
        }
    }),
    exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            delay: 0.025 * i,
            ease: [0.7, 0, 0.84, 0]
        }
    })
}
